"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.render = exports.setOpen = exports.get = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var rogueMonofont_sidecar_1 = require("@dive/fonts/rogueMonofont-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(false);
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 0;
    var th = 0;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiGame);
    canvas.autoOffset = false;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {});
    return obj;
};
var setOpen = function (isOpen) {
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
};
exports.setOpen = setOpen;
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var x = 20; //gb.width - 400
    var y = gb.height - 20;
    var w = 200;
    var h = 200;
    var sy = y;
    var sx = x;
    var addText = function (text, ox, oy) {
        if (ox === void 0) { ox = 0; }
        if (oy === void 0) { oy = 0; }
        var t = voyageUiCanvas_sidecar_1.voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3);
        stevieTexts2_sidecar_1.stevieTexts2.setWrapWidth(t, w - 60);
        y += 20;
        return t;
    };
    var addSpacer = function () {
        y += 30;
    };
    // Survival time in bottonm left
    var t = addText(voyageGameStatus_sidecar_1.voyageGameStatus.getSurvivalTime());
    stevieTexts2_sidecar_1.stevieTexts2.setScale(t, 4);
    var maxFrame = 999;
    // Current simulation frame
    y -= 20;
    x += 130;
    t = addText('' + (diveSimulationManager_sidecar_1.diveSimulationManager.get().currentSimuationFrame % maxFrame));
    stevieTexts2_sidecar_1.stevieTexts2.setScale(t, 4);
    // Target simulation frame
    y -= 20;
    x += 50;
    t = addText('/' + (diveSimulationManager_sidecar_1.diveSimulationManager.get().simulateToFrame % maxFrame));
    stevieTexts2_sidecar_1.stevieTexts2.setScale(t, 4);
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
    // Sync and CRC errors
    y -= 20;
    x += 100;
    var report = '' +
        (websockets_sidecar_1.websockets.getGameSyncNumber() % maxFrame) +
        '-crc-' +
        diveSimulationManager_sidecar_1.diveSimulationManager.get().syncErrorReport;
    t = addText(report);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(t, 4);
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
    rogueMonofont_sidecar_1.rogueMonofont.writeAbsolute(40, gb.height - 40, report);
};
exports.render = render;
var update = function () {
    var obj = get();
    if (obj.isOpen) {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
        exports.render();
    }
};
exports.update = update;
